"use strict";

exports.__esModule = true;
exports.default = void 0;
var _index = require("../../../swcp-base/js/helpers/index");
var _schema = _interopRequireDefault(require("./schema"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const languageCases = (0, _index.JoinReducerHelper)({
  localName: "contentfile",
  foreignName: "language",
  propName: "ContentFileLanguages"
});
const productCases = (0, _index.JoinReducerHelper)({
  localName: "product",
  foreignName: "vishowcontentfile",
  propName: "ProductViShowContentFiles"
});
const showroomCases = (0, _index.JoinReducerHelper)({
  localName: "showroom",
  foreignName: "vishowcontentfile",
  propName: "ShowroomViShowContentFiles"
});
const pictureCases = (0, _index.JoinReducerHelper)({
  localName: "contentfile",
  foreignName: "image",
  propName: "ContentFileImage",
  propType: "Object"
});
let list;
const contentFileAndImageCases = {
  GET_IMAGE_REQUEST: state => {
    return {
      ...state,
      list: {
        ...state.list,
        fetching: true,
        fetched: false
      }
    };
  },
  GET_IMAGE_SUCCESS: (state, action) => {
    let img = action.data;
    if (state.list.data) {
      list = {
        ...state.list,
        fetching: false,
        fetched: true,
        error: null,
        data: state.list.data.map((item /* index */) => {
          if (item.Id === img.ContentFileId) {
            return {
              ...item,
              ContentFileImage: img
            };
          } else return item;
        })
      };
    } else list = {
      ...state.list
    };
    return {
      ...state,
      list
    };
  },
  GET_IMAGE_FAILURE: (state, action) => {
    return {
      ...state,
      single: {
        ...state.single,
        fetching: false,
        fetched: true,
        error: action.data
      }
    };
  }
};
const Reducer = new _index.ReducerHelper({
  singular: "vishowcontentfile",
  plural: "vishowcontentfiles"
}, {
  ...languageCases,
  ...productCases,
  ...showroomCases,
  ...pictureCases,
  ...contentFileAndImageCases
}, {
  schema: _schema.default
});
const reducer = (state, action) => {
  return Reducer.reduce(state, action);
};
var _default = exports.default = reducer;
module.exports = exports.default;